<template>
  <div>
    <MenuTitle :close="close">{{$t('model.footerQuickLink')}}</MenuTitle>
    <menu-item class="pt-0" :label="$t('title')" />
    <base-input v-model="target.title" model-key="children" :target-index="childrenIndex" target-key="title" @input="titleChange" />
    <menu-item class="menu-item-switch" :label="$t('menu.headNav')">
      <nav-add :model="target" target-key="children" :site="site" :target-index="childrenIndex" @change="navChange" @edit="handleShowBackNavEditer" />
    </menu-item>
    <menu-item label="Logo图片">
      <menu-switch v-model="target.logoVisible" label="显示" />
    </menu-item>
    <delete-block-dialog-trigger
      class="mt-4"
      @delete-block="deleteBlock"
    >
    </delete-block-dialog-trigger>
  </div>
</template>

<script>
import {FooterQuickLinkWidgetModel} from '../../model'
import FooterMixin from './mixinEdit'
import menuTitle from "~/components/menu/menuTitle.vue"
import NavAdd from "~/components/menu/navAdd";
import MenuSwitch from "~/components/menu/menuSwitch.vue";

export default {
  name: "FooterQuickLinkWidgetEdit",
  _key: 'navediter',
  components: {
    MenuSwitch,
    NavAdd,
    menuTitle
  },
  mixins: [FooterMixin],
  props: {
    site: {
      type: Object,
      default() {
        return {}
      }
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    target: {
      type: Object,
      default() {
        return new FooterQuickLinkWidgetModel()
      }
    }
  },
  computed: {
    childrenIndex() {
      return this.model.children.findIndex(item => item.id === this.target.id)
    }
  },
  created() {
    //
  },
  methods: {
    navChange(value, item) {},
    handleShowBackgroundMenu(target) {
      this.openThreeMenu('background', this.target)
    },
    handleShowBackNavEditer(info) {
      this.openThreeMenu(this.$options._key, info)
    },
    titleChange() {
      this.target.isTitleEdit = true
    }
  }
}
</script>

<style lang="less" scoped>
.nav-add-wrap {
  .navs {
    .nav-item {
      .label {
        font-size: 16px;
        color: #FFFFFF;
        font-weight: 400;
        margin-bottom: 8px;
        padding-left: 14px;
        position: relative;
      }

      .label.icon::before {
        display: block;
        content: '';
        position: absolute;
        top: 8px;
        left: 0;
        width: 6px;
        height: 6px;
        background: @primary-color;
        border-radius: 100%;
      }

      .right {
        svg:first-child {
          margin-right: 16px;
        }
      }

    }
  }

  .add-nav {
    width: 100%;
    // padding: 0px 22px;
    background: #151724;
    // margin-top: 18px;
    .btn {
      height: 40px;
      line-height: 40px;
      padding: 0 16px;
      cursor: pointer;
      border: 0.5px dashed rgba(255, 255, 255, 0.6);
      border-radius: 2px;

      span {
        margin-left: 8px;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }
}

</style>
